import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import classes from './NavPanel.module.scss';
import { GeneralContext } from '../../context/generalContext';
import iconRight from '../../images/icon-right.svg';

export default function NavPanel({ name, link, name2, link2, name3, link3 }) {
  const { setActiveMenuItem, activeLanguage } = useContext(GeneralContext);

  return (
    <>
      <ul className={classes.top} itemScope itemType='https://schema.org/BreadcrumbList'>
        <li itemProp='itemListElement' itemScope itemType='https://schema.org/ListItem'>
          <Link
            to={activeLanguage === 1 ? '/' : '/en'}
            className={classes.main}
            onClick={() => setActiveMenuItem()}
            title={activeLanguage === 1 ? 'Главная' : 'Main'}
            itemProp='item'
          >
            <span itemProp='name'>{activeLanguage === 1 ? 'Главная' : 'Main'}</span>
            <meta itemProp='position' content='0' />
          </Link>
        </li>
        {name && link && (
          <>
            <img src={iconRight} alt='>' className={classes.arrowRightImg} />
            <li itemProp='itemListElement' itemScope itemType='https://schema.org/ListItem'>
              <Link to={link} className={classes.main} title={name} itemProp='item'>
                <span itemProp='name'>{name}</span>
                <meta itemProp='position' content='1' />
              </Link>
            </li>
          </>
        )}
        {name2 && link2 && (
          <>
            <img src={iconRight} alt='>' className={classes.arrowRightImg} />
            <li itemProp='itemListElement' itemScope itemType='https://schema.org/ListItem'>
              <Link to={link2} className={classes.main} title={name2} itemProp='item'>
                <span itemProp='name'>{name2}</span>
                <meta itemProp='position' content='2' />
              </Link>
            </li>
          </>
        )}
        {name3 && link3 && (
          <>
            <img src={iconRight} alt='>' className={classes.arrowRightImg} />
            <li itemProp='itemListElement' itemScope itemType='https://schema.org/ListItem'>
              <Link to={link3} className={classes.main} title={name3} itemProp='item'>
                <span itemProp='name'>{name3}</span>
                <meta itemProp='position' content='3' />
              </Link>
            </li>
          </>
        )}
      </ul>
    </>
  );
}
